import React from "react";
import { Box, TextField, Button, Typography, InputAdornment, useMediaQuery, useTheme } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";

const ProductForm = ({ handleNext, handleBack, activeStep, steps, formData, setFormData,errors }) => {
  const theme = useTheme();
  const [isDesktop, setIsDesktop] = React.useState(window.innerWidth >= theme.breakpoints.values.md);
  React.useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= theme.breakpoints.values.md);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [theme]);

  return (
    <Box
      sx={{
        maxWidth: isDesktop ? 600 : "100%",
        width: "100%",
        minWidth: "300px",
        margin: "auto",
        padding: isDesktop ? 3 : 2,
        borderRadius: 2,
        boxShadow: 3,
        bgcolor: "#fff",
      }}
    >
      <Typography
        variant="h5"
        align="center"
        color="#5604F6"
        sx={{ ...theme.typography.urbanist800, fontSize: isDesktop ? "36px" : "24px" }}
      >
        Add Product Details
      </Typography>


  <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
        <Box sx={{ p: 1,  bgcolor: "#eee", borderRadius: 2, display: "inline-block" }}>
                         <Typography variant="caption" color="#5604F6" fontWeight={500}  sx={{ fontSize: isDesktop ? 18 : 20 }} >
                           Instructions
                         </Typography>  
                       </Box>
  <Typography variant="body2" sx={{ color: "gray",  textAlign: "justify" ,  fontSize: isDesktop ? 18  : 20 }} >
          Choose the most relevant category for your product to help buyers find it easily.
        </Typography>
      </Box>

      {/* Product Title */}
      <Typography sx={{ ...theme.typography.urbanist800, fontSize: "16px", mt: 2 }}>Product Title</Typography>
      <TextField
        fullWidth
        required
        margin="normal"
        name="title"
          placeholder="Enter product title"
          error={!!errors.title} 
          helperText={errors.title}
        value={formData?.title || ""}
        onChange={(e) => setFormData({ ...formData, title: e.target.value })}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "12px",
            backgroundColor: "#fff",
             fontSize: isDesktop ? 18 : 20
          },
          "& .MuiInputBase-input::placeholder": {
            color: "#A0A0A0",
            fontSize: isDesktop ? 14 : 18
          },
        }}
      />


      {/* Description */}
      <Typography sx={{ ...theme.typography.urbanist800, fontSize: "16px", mt: 2 }}>Description</Typography>
      <TextField
        fullWidth
        required
        margin="normal"
        name="description"
         placeholder="Write a detailed description, including features, condition, etc."
        multiline
        minRows={4}
        value={formData?.description || ""}
        onChange={(e) => setFormData({ ...formData, description: e.target.value })}
        error={!!errors.description}
        helperText={errors.description}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "12px",
            backgroundColor: "#fff",
            fontSize: isDesktop ? 18 : 20
          },
          "& .MuiInputBase-input::placeholder": {
            color: "#A0A0A0",
            fontSize: isDesktop ? 14 : 18
          },
        }}
      />

      {/* Location & Price */}
      <Box sx={{ display: "flex", flexDirection: isDesktop ? "row" : "column", gap: 2, mt: 2 }}>
      <Box sx={{ width: "100%" }}>
          <Typography sx={{ ...theme.typography.urbanist800, fontSize: "16px", mt: 2 }}>Location</Typography>
          <TextField
            fullWidth
            required
            name="location"
              placeholder="Enter your location"
            value={formData?.location || ""}
            onChange={(e) => setFormData({ ...formData, location: e.target.value })}
            error={!!errors.location}
            helperText={errors.location}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <LocationOnIcon sx={{ color: "#5604F6" }} />
                </InputAdornment>
              ),
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "12px",
                backgroundColor: "#fff",
                fontSize: isDesktop ? 18 : 20
              },
              "& .MuiInputBase-input::placeholder": {
                color: "#A0A0A0",
                fontSize: isDesktop ? 14 : 18
              },
            }}
          />
        </Box>

        <Box sx={{ width: "100%" }}>
          <Typography sx={{ ...theme.typography.urbanist800, fontSize: "16px", mt: 2 }}>Price</Typography>
          <TextField
  fullWidth
  required
  name="price"
  placeholder="₦ 0.00"
  value={formData?.price ? new Intl.NumberFormat().format(formData.price) : ""}
  error={!!errors.price}
  helperText={errors.price}
  onChange={(e) => {
    const rawValue = e.target.value.replace(/,/g, ""); 
    if (!isNaN(rawValue) && rawValue !== "") {
      setFormData({ ...formData, price: Number(rawValue) });
    }
  }}
  sx={{
    "& .MuiOutlinedInput-root": {
      borderRadius: "12px",
      backgroundColor: "#fff",
      fontSize: isDesktop ? 18 : 20
    },
    "& .MuiInputBase-input::placeholder": {
      color: "#A0A0A0",
      fontSize: isDesktop ? 14 : 18
    },
  }}
/>

        </Box>
      </Box>
      {/* Buttons */}
      <Box sx={{ display: "flex", justifyContent:"center", flexDirection: isDesktop ? "row" : "column", mt: 3, width: "100%", gap: 2 }}>
        <Button
   
    sx={{
      width: isDesktop ? "40%" : "100%",
      padding: "10px 20px", 
      borderRadius: "25px", 
      backgroundColor: "#EEE6FE  !important",
      color: "#5604F6!important",
      textTransform: "none",
      fontSize: isDesktop ? "16px" : "18px",
      "&:hover": { backgroundColor: "#B0B0B0" },
    }}
    onClick={handleBack}
    disabled={activeStep === 0}
  >
    {"< Back To Step 1"}
  </Button>

  <Button
    variant="contained"
    sx={{
      width: isDesktop ? "40%" : "100%", 
      padding: "10px 20px", 
      borderRadius: "25px",
      backgroundColor: "#5604F6 !important",
      color: "#EEE6FE !important",
      textTransform: "none",
      fontSize: isDesktop ? "16px" : "18px",
      "&:hover": { backgroundColor: "#4b00c2" },
    }}
    onClick={handleNext}
  >
    {activeStep === steps.length - 2 ? "Review" : "Next →"}
  </Button>
</Box>

    </Box>
  );
};

export default ProductForm;
